/**
 * Auto-Fill Field Wrapper Component
 * Wraps form fields and displays auto-fill suggestions below them
 */

import React from 'react';
import AutoFillFieldSuggestion from './AutoFillFieldSuggestion';
import './AutoFillFieldWrapper.css';

const AutoFillFieldWrapper = ({
    fieldName,
    suggestions = {},
    isLoading = false,
    showSuggestions = false,
    currentField = null,
    onApplyField,
    onIgnoreField,
    children,
    className = ''
}) => {
    // Only show suggestions for the current field being typed in
    const shouldShowSuggestions = showSuggestions && currentField === fieldName;
    // Show all suggestions when this is the current field
    const fieldSuggestions = shouldShowSuggestions ? suggestions : {};

    return (
        <div className={`auto-fill-field-wrapper ${className}`}>
            {children}
            <AutoFillFieldSuggestion
                fieldName={fieldName}
                suggestions={fieldSuggestions}
                isLoading={isLoading}
                showSuggestions={shouldShowSuggestions}
                onApplyField={onApplyField}
                onIgnoreField={onIgnoreField}
            />
        </div>
    );
};

export default AutoFillFieldWrapper;
